<template>
  <div>
    <div class="title h5 pt-3 pb-3 mb-0">Register</div>
    <form class="content form" @submit.prevent autocomplete="off">
      <div class="row">
        <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div style="height: 0px; overflow: hidden">
            Username
            <input
              type="text"
              name="fake_username"
              class="login-input"
              label="username"
            />
            Email
            <input
              type="email"
              name="fake_email"
              class="login-input"
              label="email"
            />
            Password
            <input
              type="password"
              name="fake_password"
              class="login-input"
              label="password"
            />
          </div>
          <SInput
            class="registration-input username-input"
            label="Username"
            ref="username"
            fieldClass="form-input"
            :required="true"
            data-cy="lpRegistrationUsername"
            v-model="credentials.username"
            :class="[
              {
                'has-value': credentials.username && !hasUsernameError,
                'has-error': hasUsernameError,
              },
            ]"
            @input="clearError('username')"
          />
          <p
            v-if="usernameEmpty !== true"
            id="error-container"
            class="text-danger text-center text-wrap"
          >
            {{ usernameEmpty }}
          </p>
          <SInput
            name="new-email"
            autocomplete="new-email"
            label="Email"
            ref="email"
            fieldClass="form-input"
            :required="true"
            data-cy="lpRegistrationEmail"
            class="registration-input email-input"
            v-model="credentials.email"
            :class="[
              {
                'has-value': credentials.email && !hasEmailError,
                'has-error': hasEmailError,
              },
            ]"
            @input="clearError('email')"
          />
          <p
            v-if="emailTst !== true"
            id="error-container"
            class="mb-2 text-danger text-center text-wrap"
            style="margin-top: -1.1em"
          >
            {{ emailTst }}
          </p>
          <div
            data-toggle="tooltip"
            data-placement="bottom"
            data-html="true"
            title="<div class='text-left'><b>Password must have</b><br>
              - at least 1 number<br>
              - at least 1 lowercase letter<br>
              - at least 1 uppercase letter<br>
              - at least 8 characters
              </div>"
          >
            <VuePassword
              v-model="credentials.password"
              :strength="passwordScore"
              disableToggle
            >
              <template v-slot:password-input>
                <div
                  class="label-floating col-12 pl-0 pr-0 mb-0 registration-input"
                  :class="{
                    'has-value': credentials.password && !hasPasswordError,
                    'has-error': hasPasswordError,
                  }"
                >
                  <md-field class="form-input">
                    <label>Password</label>
                    <md-input
                      v-model="credentials.password"
                      @input="updateStrength(credentials.password)"
                      type="password"
                      class="form-control"
                      :required="true"
                      name="new-password"
                      autocomplete="new-password"
                      :id="dynamicID()"
                      data-cy="lpRegistrationPassword"
                    >
                    </md-input>
                  </md-field>
                </div>
              </template>
            </VuePassword>
            <span class="pass-strength">{{ password_strength }}</span>
          </div>
          <p
            v-if="spelling !== true"
            id="error-container"
            class="text-danger text-center text-wrap"
          >
            {{ spelling }}
          </p>
          <SInput
            label="Password confirmation"
            type="password"
            ref="passwordConfirmation"
            fieldClass="form-input"
            :required="true"
            name="new-password"
            autocomplete="new-password"
            data-cy="lpRegistrationConfirmPassword"
            class="mt-4"
            v-model="confirmPassword"
            :class="[
              {
                'has-value': confirmPassword && !hasConfirmPasswordError,
                'has-error': hasConfirmPasswordError,
              },
            ]"
            @input="clearError('confirmPassword')"
          />
          <p
            v-if="pwdTst !== true"
            id="error-container"
            style="margin-top: -17px"
            class="text-danger text-center text-wrap"
          >
            {{ pwdTst }}
          </p>
          <SCheckbox
            style="margin-top: 3rem"
            label="I accept the Swampum community’s
                <a class='checkbox-terms'
                  href='https://www.iubenda.com/terms-and-conditions/43113518'
                  target='_blank'
                  rel='noopener' style=color:#05919Bs>
                    Terms and Conditions
                </a>"
            v-model="checkTerms"
            data-cy="lpRegistrationAcceptTerms"
          />
          <div
            id="error-container"
            v-if="spelling && pwdTst && emailTst && checkTerms === false"
            style="margin-top: -17px"
          >
            <p class="text-danger text-center text-wrap">
              You must accept Terms and Conditions to proceed
            </p>
          </div>
          <!-- use class "while-no-fbLogin" just until facebook login fix  -->
          <div class="actions while-no-fbLogin md-layout md-alignment-center-space-between">
            <SButtonMaterial
              class="submit-login-btn"
              buttonType="button"
              color="primary"
              textColor="white"
              materialClass="dense"
              text="register"
              @button="register"
              data-cy="lpRegistrationSubmit"
            />
          </div>
          <!-- Disabling facebook login until fixed -->
          <!-- <div class="or"></div>
          <SButton
            text="<i class='fab fa-facebook-f' aria-hidden='true'></i>Register with Facebook"
            size="lg"
            class="bg-facebook full-width btn-icon-left login-btn"
            :landingPageButton="true"
            @button="fbLogin"
          /> -->
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SInput from "@/material-components/atoms/SInput.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
// import SButton from "@/components/atoms/SButton.vue";
import SCheckbox from "@/components/atoms/SCheckbox.vue";
import { mapActions } from "vuex";
import VuePassword from "vue-password";
import zxcvbn from "zxcvbn";
import Global from "@/constants/Global.js";

export default {
  name: "SRegistrationForm",
  components: {
    SInput,
    // SButton,
    SButtonMaterial,
    SCheckbox,
    VuePassword,
  },
  props: ["redirectTo"],
  data() {
    return {
      credentials: {
        username: "",
        email: "",
        password: "",
        code: "",
      },
      spelling: null,
      pwdTst: null,
      emailTst: null,
      usernameEmpty: null,
      checkTerms: false,
      confirmPassword: "",
      hasUsernameError: false,
      hasEmailError: false,
      hasConfirmPasswordError: false,
      hasPasswordError: false,
      strengthMsgs: [
        "Very Weak Password",
        "Weak Password",
        "Medium Password",
        "Strong Password",
        "Very Strong Password",
      ],
      passwordScore: 0,
    };
  },
  methods: {
    ...mapActions(["signup"]),
    dynamicID() {
      return "dynamicID-" + Math.floor(Math.random() * Date.now().toString());
    },
    fbLogin() {
      window.location.replace(`${Global.getServerDomain()}/auth/facebook`);
    },
    async register() {
      this.checkUsername();
      this.checkEmail();
      this.checkSpelling();
      this.checkPassword();

      this.checkErrs();

      if (
        this.credentials.username &&
        this.spelling === true &&
        this.pwdTst === true &&
        this.emailTst === true &&
        this.checkTerms === true
      ) {
        if (this.$route.query.code) {
          this.credentials.code = this.$route.query.code;
        }
        this.signup(this.credentials);
        this.$emit("register");
      }
    },
    updateStrength(password) {
      this.hasPasswordError = false;
      this.spelling = null;
      this.passwordScore = zxcvbn(password).score;
      const trTest = /^(?=.*[A-Z])(?=.*\d)(?=.{8,})/;
      return Boolean(trTest.test(password));
    },
    checkSpelling() {
      if (!this.credentials.password) {
        this.spelling = "Password cannot be empty";
        this.hasPasswordError = true;
      } else if (!(/(?=.*[A-Z])/).test(this.credentials.password)) {
        this.spelling = "Password must have at least 1 uppercase letter";
        this.hasPasswordError = true;
      } else if (!(/(?=.*\d)/).test(this.credentials.password)) {
        this.spelling = "Password must have at least 1 number";
        this.hasPasswordError = true;
      } else if (!(/(?=.{8,})/).test(this.credentials.password)) {
        this.spelling = "Password must have at least 8 charcters";
        this.hasPasswordError = true;
      } else if (!(/(?=.*[a-z])/).test(this.credentials.password)) {
        this.spelling = "Password must have at least 1 lowercase letter";
        this.hasPasswordError = true;
      } else {
        this.spelling = true;
        this.hasPasswordError = false;
      }
    },
    checkPassword() {
      if (this.credentials.password !== this.confirmPassword) {
        this.pwdTst = "Both password fields must be the same";
        this.hasConfirmPasswordError = true;
      } else {
        this.pwdTst = true;
      }
      if (!this.confirmPassword) this.hasConfirmPasswordError = true;
    },
    checkEmail() {
      if (
        !(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        ).test(this.credentials.email)
      ) {
        this.emailTst = "This field must be a valid email";
        this.hasEmailError = true;
      } else {
        this.emailTst = true;
        this.hasEmailError = false;
      }
    },
    checkUsername() {
      if (!this.credentials.username) {
        this.usernameEmpty = "This field cannot be empty";
        this.hasUsernameError = true;
        return;
      }
      this.usernameEmpty = null;
      this.hasUsernameError = false;
    },
    clearError(input) {
      switch (input) {
        case "username":
          this.hasUsernameError = false;
          this.usernameEmpty = null;
          break;
        case "email":
          this.hasEmailError = false;
          this.emailTst = null;
          break;
        case "confirmPassword":
          this.hasConfirmPasswordError = false;
          this.pwdTst = null;
          break;
      }
    },
    checkErrs() {
      if (this.hasError) {
        this.$emit("hasError");
      } else {
        this.$emit("noError");
      }
    },
  },
  computed: {
    hasError() {
      return (
        this.hasUsernameError ||
        this.hasEmailError ||
        this.hasConfirmPasswordError ||
        this.hasPasswordError
      );
    },
    password_strength() {
      return this.strengthMsgs[zxcvbn(this.credentials.password).score];
    },
  },
  mounted() {
    $("[data-toggle='tooltip']").tooltip();
    setTimeout(() => {
      this.$refs.username.focus();
    }, 500);
    setTimeout(() => {
      this.hasPasswordError = false;
    }, 501);
  },
};
</script>

<style scoped>
.submit-login-btn {
  width: 60%;
  height: 41px;
  font-size: 14px;
}
.actions {
  justify-content: center;
}
.while-no-fbLogin {
  margin-top: 80px;
}
.md-field {
  margin: 0.1875rem 0 -0.05rem;
}
.title {
  margin-right: auto;
}
.md-list-item-text p {
  white-space: normal;
  padding-bottom: 0;
}
.form-input {
  border: 1px rgba(0, 0, 0, 0.12) solid;
  border-radius: 3px;
}
.md-field:after {
  height: 0;
}
.md-field:before {
  height: 0px;
}
input {
  margin-left: 11px;
}
.md-input {
  padding: 7px 0px 10px 0px;
  width: 100%;
  height: 100%;
}
label {
  font-size: 14px;
  margin-left: 11px;
  top: 15px;
}
.registration-input {
  margin-top: 0.8rem !important;
}
</style>

<style lang="scss" scoped>
.md-focused {
  border-color: $primary;
}
.md-field.md-theme-swampum-primary.md-focused label {
  color: $primary;
}
.pass-strength {
  color: $dark !important;
}
</style>

<style lang="scss">
.has-value .md-field.md-theme-swampum-primary label {
  color: $primary !important;
}
.has-value .form-input {
  border: 1px solid $primary;
}
.has-error .md-field.md-theme-swampum-primary label {
  border: $danger !important;
}
.has-error .form-input {
  border: 1px solid $danger !important;
}
.username-input.has-error .form-input {
  margin-bottom: 0;
}
.email-input.has-error .form-input {
  margin-bottom: 1rem;
}
.checkbox-terms {
  color: $tertiary !important;
}
</style>
